import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { MapPin, Clock, ArrowRight } from "lucide-react";
const featuredJourneys = [{
  id: 1,
  title: "United Kingdom",
  location: "Oxford & London",
  description: "Home to the world's oldest universities and a global financial hub. Experience academic tradition paired with modern innovation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623446/img/big_ben_uk.png",
  duration: "12-16 Weeks",
  price: "98% Success",
  link: "/DestinationsPage"
}, {
  id: 2,
  title: "United States",
  location: "Ivy League & Beyond",
  description: "The pinnacle of global research and diverse opportunity. Access cutting-edge facilities and a vast network of industry leaders.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623446/img/statue_of_liberty_usa.png",
  duration: "16-20 Weeks",
  price: "95% Success",
  link: "/DestinationsPage"
}, {
  id: 3,
  title: "Canada",
  location: "Toronto & Vancouver",
  description: "A welcoming landscape for international talent with high-ranking institutions and exceptional post-graduate career pathways.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623446/img/toronto_skyline_canada.png",
  duration: "14-18 Weeks",
  price: "97% Success",
  link: "/DestinationsPage"
}];
export default function FeaturedJourneys() {
  return <section data-section-id="106514" id="global-education-corridors" className="bg-background py-24 sm:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col items-center text-center">
          <Badge variant="outline" className="mb-4 border-secondary text-secondary font-default">
            Premier Destinations
          </Badge>
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl font-default">
            Global Education Corridors
          </h2>
          <p className="mt-4 max-w-[700px] text-lg text-muted-foreground font-default">
            Unlock unparalleled opportunities at the world's most prestigious academic hubs. We guide your ambition toward global achievement.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {featuredJourneys.map((journey, i) => <div data-index={i} key={journey.id} className="h-full">
              <Card className="group flex h-full flex-col overflow-hidden border-border/50 bg-card transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-primary/5 rounded-sm">
                <div className="relative overflow-hidden">
                  <AspectRatio ratio={4 / 5}>
                    <img src={journey.image} alt={journey.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </AspectRatio>
                  <div className="absolute right-4 top-4 z-10">
                    <Badge className="flex items-center gap-1.5 bg-background/95 px-3 py-1.5 text-sm font-semibold text-foreground shadow-sm backdrop-blur-md hover:bg-background/95 rounded-sm">
                      <Clock className="h-3.5 w-3.5 text-secondary" />
                      {journey.duration}
                    </Badge>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-transparent to-transparent opacity-60 transition-opacity duration-300 group-hover:opacity-40" />
                </div>

                <div className="flex flex-1 flex-col justify-between p-6">
                  <div>
                    <div className="mb-3 flex items-center gap-1.5 text-sm font-medium text-muted-foreground font-default">
                      <MapPin className="h-4 w-4 text-secondary" />
                      {journey.location}
                    </div>
                    <CardTitle className="mb-3 text-2xl font-bold leading-tight text-card-foreground font-default tracking-tight">
                      {journey.title}
                    </CardTitle>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground line-clamp-3 font-default">
                      {journey.description}
                    </CardDescription>
                  </div>

                  <div className="mt-8 flex items-center justify-between border-t border-border/50 pt-6">
                    <div className="flex flex-col">
                      <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground font-default">Visa Success Rate</span>
                      <span className="text-3xl font-bold text-primary tracking-tighter font-default">
                        {journey.price}
                      </span>
                    </div>
                    <Button asChild size="icon" className="h-12 w-12 rounded-sm shadow-md transition-transform group-hover:scale-110 bg-primary hover:bg-secondary">
                      <Link to={journey.link} aria-label={`View details for ${journey.title}`}>
                        <ArrowRight className="h-5 w-5" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button asChild size="lg" variant="outline" className="group border-secondary/20 hover:border-secondary hover:bg-secondary/5 rounded-sm font-default">
            <Link to="#">
              Explore All Destinations
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}